import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const WebsiteSection: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "left",
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          sx={{
            padding: 1,
            borderBottom: 4,
            borderWidth: "40%",
            marginLeft: 2,
          }}
        >
          Peterson-Daly Farms Website
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          justifyContent: "left",
          alignItems: "left",
        }}
      >
        <Typography
          variant="body1"
          color="primary"
          sx={{
            margin: 2,
          }}
        >
          In the summer of 2022 I set out to create a website for the family
          farm. Although this website uses React Typescript,&nbsp;
          <Link to="https://petersondalyfarms.com" rel="noopener noreferrer" target="__blank" >petersondalyfarms.com</Link> was built using React Javascript. As seen below,
          the website serves to highlight the history and legacy of the farm,
          and also serves as a place potential business partners can learn about
          the operation and contact my father and brother. I developed and
          designed the entire website myself, including the writings and the
          video in the masthead.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingTop: 4,
          paddingBottom: 4,
        }}
      >
        <iframe
          src="https://www.petersondalyfarms.com"
          width="100%"
          height="600"
          title="Website Preview"
        />
      </Box>
    </>
  );
};
export default WebsiteSection;
